import { gql } from 'graphql-request'

export const siteIdQuery = gql`
  query getSiteId($v1Id: Int!) {
    site: siteByV1Id(v1Id: $v1Id) {
      id
    }
  }
`
export const siteNamesQuery = (siteIds = []) => {
  const ids = siteIds ?? []
  const queryFragment = ids
    .map((_, index) => `site${index}: site(siteId: $siteId${index}) { name, siteId }`)
    .join('\n')
  const variables = ids.map((_, index) => `$siteId${index}: ID!`).join(', ')

  return gql`
  query getSiteNames(${variables}) {
     ${queryFragment}
  }
 `
}

export const sitesListQuery = gql`
  query getSitesList {
    sites {
      results {
        node {
          id
          name
          address
          status
        }
      }
    }
  }
`

export const siteCountryIsoCodeQuery = gql`
  query getSiteCountryIsoCode($siteId: ID!) {
    site(siteId: $siteId) {
      siteId
      country {
        isoCode
      }
    }
  }
`
